import { FormControl, Box, Typography } from "@mui/material"
import { useDropzone } from 'react-dropzone'
import { useCallback } from "react";
import { ButtonStato } from '../../commons/styleds/buttons';
import { useTranslation } from "../../commons/useTranslasion";
import { esES, ptBR } from "@mui/material/locale";

interface IParams {
    isEdit?: any;
    objOnEdit?: any;
    setObjOnEdit?: any;
    newObj?: any;
    setNewObj?: any;
    nameFile?: any;
    setNameFile?: any;
    urlFile?: any;
    setUrlFile?: any;
    acceptTypes?: any;
}

const InputArquivo: React.FC<IParams> = (props) => {
    const { translate, language } = useTranslation();
    const lang = language ?? "pt-br";
    let locale = ptBR;
    switch (lang.slice(0, 2)) {
        case "es":
            locale = esES
            break;
    }

    const onDrop = useCallback(
        (acceptedFiles: any) => {
            const file = acceptedFiles[0];

            if (file) {
                props.setNameFile(file.name);
                props.setUrlFile(URL.createObjectURL(file));

                props.isEdit ?
                    props.setObjOnEdit({ ...props.objOnEdit, anexo: file }) :
                    props.setNewObj({ ...props.newObj, anexo: file });
            }
        }, [props]
    );

    const abrirArquivo = () => {
        const fileUrl = props.urlFile;
        const fileName = props.nameFile || '';

        if (fileName.endsWith('.docx') || fileName.endsWith('.doc')) {
            try {

                const googleDocsUrl = `https://docs.google.com/viewerng/viewer?url=${encodeURIComponent(fileUrl)}&embedded=true`;
                window.open(googleDocsUrl, '_blank');
            } catch (error) {
                console.error(translate('erroAoAbrirDocumento'), error);

                window.open(fileUrl, '_blank');
            }
        } else {

            window.open(fileUrl, '_blank');
        }
    };

    // const handleDownload = async () => {
    //     const response = await fetch(props.urlFile);
    //     const blob = await response.blob();

    //     const url = window.URL.createObjectURL(blob);
    //     const link = document.createElement('a');
    //     link.href = url;

    //     const extension = props.urlFile.split('.').pop()?.split('?')[0] ||
    //         response.headers.get('content-type')?.split('/').pop() || '';

    //     const fileName = `${props.nameFile || `documento.${extension}`}`;
    //     link.setAttribute('download', fileName);

    //     document.body.appendChild(link);
    //     link.click();

    //     document.body.removeChild(link);
    //     window.URL.revokeObjectURL(url)
    // }

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        multiple: false,
        accept: props.acceptTypes
    });

    return (
        <FormControl fullWidth sx={{ marginTop: '20px' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography sx={{ marginBottom: '8px' }}>{translate('anexo')}</Typography>
                <Box {...getRootProps()} sx={dropzoneStyles}>
                    <input {...getInputProps()} />
                    <Typography>
                        {props.nameFile
                            ? `${translate('arquivoCarregado')}: ${props.nameFile}`
                            : `${translate('arrasteSolteUmArquivoAqui')}`}
                    </Typography>
                    {props.urlFile && (
                        <>
                            <ButtonStato variant="outlined" onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                abrirArquivo();
                            }} sx={{ marginTop: '10px' }}>
                                {translate('visualizarArquivo')}
                            </ButtonStato>
                        </>
                    )}
                </Box>
            </Box>
        </FormControl>
    )
};

const dropzoneStyles = {
    border: '2px dashed #ccc',
    borderRadius: '4px',
    padding: '20px',
    textAlign: 'center',
    cursor: 'pointer',
};

export default InputArquivo;